import React from 'react';
import Products from '../components/Products';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const ProductsPage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Banner Section */}
            <div
                className="relative h-[300px] w-full flex items-center justify-center bg-gray-900 bg-cover bg-center"
                // Banner path ko public folder ke hisaab se set karein
                style={{ backgroundImage: "url('/banner-image.jpg')" }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase tracking-wider text-center px-4">
                    Our Products
                </h1>
            </div>

            {/* Products List Section */}
            <div className="py-10">
                <Products />
            </div>
        </div>
    );
};

export default ProductsPage;